import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "footer"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = {
  key: 1,
  class: "page-number"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'page-export',
  props: {
    width: { default: "210mm" },
    page: { default: 0 },
    scale: { default: 1 },
    showPages: { type: Boolean, default: true },
    showFooter: { type: Boolean },
    footerTitle: {},
    footerSubtitle: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v79dd76a5": (_ctx.width),
  "v4421fae9": (_ctx.$props.scale)
}))

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["page", {
      pages: __props.showPages,
      footer: __props.showFooter,
      print: _ctx.$store.getters.print,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (__props.showFooter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.footerTitle), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(__props.footerSubtitle), 1)
        ]))
      : _createCommentVNode("", true),
    (__props.showPages)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.page), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})